import { render, staticRenderFns } from "./ModalVerDetalle.vue?vue&type=template&id=184f3a32&scoped=true&"
import script from "./ModalVerDetalle.vue?vue&type=script&lang=js&"
export * from "./ModalVerDetalle.vue?vue&type=script&lang=js&"
import style0 from "./ModalVerDetalle.vue?vue&type=style&index=0&id=184f3a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f3a32",
  null
  
)

export default component.exports